<div class="fields row" [formGroup]="group()">
    @for (field of hours; track field.control) {
        <label class="field">
            <span class="label">{{ field.label }}</span>
            <kendo-textbox [formControlName]="field.control" placeholder="HH:MM"></kendo-textbox>
            @if (group().controls[field.control].invalid) {
                <span class="error">{{ "FLIGHT_LIST.edit.errors.duration" | translate }}</span>
            }
        </label>
    }
    <label class="field check">
        <input type="checkbox" kendoCheckBox formControlName="windGR33" />
        <span class="label">Wind &gt; 33 Kts</span>
    </label>
    <label class="field check">
        <input type="checkbox" kendoCheckBox formControlName="windGR45" />
        <span class="label">Wind &gt; 45 Kts</span>
    </label>
</div>
